module.exports = __webpack_public_path__ + "static/media/16UNODC20.157340d6.jpg";